/* import __COLOCATED_TEMPLATE__ from './balance.hbs'; */
import Component from '@glimmer/component';

export default class SiteBillingAccountHistoryCellsBalance extends Component {
  get balanceValue() {
    const item = this.args.item;

    switch (item.constructor.modelName) {
      case 'appointment':
      case 'group-appointment':
        return (item.fee || 0) - (item.totalAllocatedAmount || 0);
      case 'invoice-item':
        return item.remainingAmount;
      case 'payment':
        return -item.amount;
      default:
        return null;
    }
  }
}
